import { Routes } from '@angular/router';

import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
// eslint-disable-next-line @stylistic/max-len
import { DatacenterViewCustomizationComponent } from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { SERVICE_ANALYTICS } from '../shared/models/list';
import { ListFilterComponent } from '../shared/components/filter/list-filter.component';

import { DispatchAdviceCardComponent } from './components/card/dispatch-advice-card.component';
import { InvoiceCardComponent } from './components/card/invoice-card.component';
import { OrderAcknowledgmentCardComponent } from './components/card/order-acknowledgment-card.component';
import { CertificateCardComponent } from './components/card/certificate-card.component';
import { CommercialDocumentsListComponent } from './components/list/commercial-documents-list.component';
import { XcarbDocumentCardComponent } from './components/card/xcarb-card.component';

export const routes: Routes = [
	{
		path: '',
		children: [
			{
				path: '',
				redirectTo: 'list',
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.COMMERCIAL_DOCUMENTS }
			},
			{
				path: 'list',
				children: [
					{
						path: '',
						component: CommercialDocumentsListComponent,
						data: {
							pageName: 'Commercial Documents - List',
							service: SERVICE_ANALYTICS.COMMERCIAL_DOCUMENTS,
							type: 'document'
						}
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: { pageName: 'Commercial Documents - Filter', service: SERVICE_ANALYTICS.DOC }
					}
				]
			},
			{
				path: 'cards',
				children: [
					{
						path: 'invoice-card',
						component: InvoiceCardComponent,
						data: { pageName: 'Commercial Documents - Invoice card', service: SERVICE_ANALYTICS.INVOICE }
					},
					{
						path: 'invoice-card/:id',
						component: InvoiceCardComponent,
						data: { pageName: 'Commercial Documents - Invoice Card', service: SERVICE_ANALYTICS.INVOICE }
					},
					{
						path: 'order-acknowledgment-card/:id',
						component: OrderAcknowledgmentCardComponent,
						data: {
							pageName: 'Commercial Documents - Order Acknowledgment Card',
							service: SERVICE_ANALYTICS.ORDER_ACKNOWLEDGMENT
						}
					},
					{
						path: 'certificate-card/:id',
						component: CertificateCardComponent,
						data: {
							pageName: 'Commercial Documents - Certificate Card',
							service: SERVICE_ANALYTICS.CERTIFICATE
						}
					},
					{
						path: 'xcarb-document-card/:id',
						component: XcarbDocumentCardComponent,
						data: {
							pageName: 'Commercial Documents - Xcarb Card',
							service: SERVICE_ANALYTICS.XCARB
						}
					},
					{
						path: 'dispatch-advice-card/:id',
						component: DispatchAdviceCardComponent,
						data: {
							pageName: 'Commercial Documents - Dispatch Advice Card',
							service: SERVICE_ANALYTICS.DISPATCH_ADVICE
						}
					}
				]
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Commercial Documents - Datacenter',
							service: SERVICE_ANALYTICS.COMMERCIAL_DOCUMENTS,
							type: 'document',
							title: 'datacenter.commercial-documents',
							exportExcelName: 'Commercial documents'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: {
							pageName: 'Commercial Documents - Datacenter Customization',
							service: SERVICE_ANALYTICS.COMMERCIAL_DOCUMENTS
						}
					}
				]
			}
		]
	}
];
